<template>
  <div id="onebyone-product-search">
    <component :is="dynamicComponent" :keyword="keyword" :page="page"></component>
  </div>
</template>

<script>
import deviceMixins from "../mixins/deviceMixins";
import MobileProductSearch from "./mobile/ProductSearch";
import DesktopProductSearch from "./desktop/ProductSearch";

export default {
  props: {
    page: {
      type: String,
      default: "1"
    },
    keyword: String
  },
  mixins: [deviceMixins("ProductSearch")],
  components: {
    MobileProductSearch,
    DesktopProductSearch
  }
};
</script>